<template>
	<div class="relative">
		<!-- Sections, their order and their schedules come from Storefront › Home page in the admin. -->
		<template v-for="section in sections" :key="section.id">
			<IntroVideo v-if="section.type === 'introVideo'" />
			<HeroTiles v-else-if="section.type === 'hero'" :tiles="section.tiles" />
			<!-- 3 Services that are offered by In His Hands -->
			<AboutService v-else-if="section.type === 'sellingPoints'" class="mt-10" />
			<PopularProducts v-else-if="section.type === 'popularProducts'" :items="section.items" class="mt-10" />
			<FeaturedProducts v-else-if="section.type === 'featuredProducts'" :items="section.items" class="mt-20" />
			<PopularCategories v-else-if="section.type === 'popularBrands'" :brand-ids="section.brandIds" :items="section.items" />
			<Midwife v-else-if="section.type === 'midwife'" class="md:mt-10" />
			<MissionWWA v-else-if="section.type === 'missionVision'" />
			<ShortAbout v-else-if="section.type === 'about'" />
			<HtmlSection v-else-if="section.type === 'html'" :section="section" class="mt-10" />
			<BannerSection v-else-if="section.type === 'banner'" :section="section" class="mt-10" />
		</template>
	</div>
</template>
<script>
import IntroVideo from '../layout/intro-video.vue'
import HeroTiles from './ihh-items/hero-tiles.vue'
import AboutService from './ihh-items/about-service.vue'
import Midwife from './ihh-items/midwife.vue'
import MissionWWA from './ihh-items/mission-wwa.vue'
import ShortAbout from './ihh-items/short-about.vue'
import FeaturedProducts from './ihh-items/featured-products.vue'
import PopularProducts from './ihh-items/popular-products.vue'
import PopularCategories from './ihh-items/popular-categories.vue'
import HtmlSection from './ihh-items/home-html-section.vue'
import BannerSection from './ihh-items/home-banner-section.vue'
import { loadHomePage, readyHomePage } from '../../helpers/homePage'

// The longest the route waits for the home page data before showing the page anyway.
const WAIT_MS = 3000

export default {
	components: { IntroVideo, HeroTiles, AboutService, Midwife, MissionWWA, ShortAbout, PopularProducts, FeaturedProducts, PopularCategories, HtmlSection, BannerSection },
	inject: ['store'],
	// Stay on the current page until the layout and rows are here, so the home
	// page appears complete instead of filling in. Usually they already are:
	// the server sent them with the page, or they were fetched in the background
	// (helpers/homePage.js).
	async beforeRouteEnter() {
		if (readyHomePage()) return
		await Promise.race([loadHomePage(), new Promise((resolve) => setTimeout(resolve, WAIT_MS))])
	},
	data() {
		return {
			// Empty only when the route stopped waiting; mounted() fills it then.
			sections: readyHomePage() || [],
		}
	},
	async mounted() {
		// Set document title to site name
		document.title = 'In His Hands Birth Supply'
		if (!this.sections.length) this.sections = await loadHomePage()
	},
}
</script>
